const GRID_NUMBERING_SLOT_ORDER = {
  1: [1, 3, 2, 4],
  2: [1, 4, 2, 3],
  3: [4, 3, 1, 2],
  4: [4, 1, 3, 2],
  5: [1, 2, 4, 3],
  6: [1, 2, 3, 4],
};

function gridSlotOrder(gridNumbering) {
  const setting = Number(gridNumbering || 1);
  return GRID_NUMBERING_SLOT_ORDER[setting] || GRID_NUMBERING_SLOT_ORDER[1];
}

export {
  GRID_NUMBERING_SLOT_ORDER,
  gridSlotOrder,
};
